'use strict';

import * as Redux from 'redux';
import My from './reducers/my';
import BraintreeToken from './reducers/braintreeToken';
import BraintreeClient from './reducers/braintreeClient';
import HostedFields from './reducers/hostedFields';
import LocalFields from './reducers/localFields';
import CartContents from '../cart/reducers/cart-contents';
import PostTokenCart from './reducers/braintreePostTokenCart';
import TOS from './reducers/tos.js';
import TOSAgreed from './reducers/tos-agreed.js';
import CreateNewTOSAgreed from './reducers/create-new-tos-agreed.js';
import Logout from '../../login/logout/reducers/logout.js';
import SwitchAccounts from '../../login/logout/reducers/switch-accounts';

export default Redux.createStore(
    Redux.combineReducers({
        my: My,
        braintreeToken: BraintreeToken,
        braintreeClient: BraintreeClient,
        cartContents: CartContents,
        hostedFields: HostedFields,
        localFields: LocalFields,
        postTokenCart: PostTokenCart,
        tos: TOS,
        tosAgreed: TOSAgreed,
        createNewTosAgreed: CreateNewTOSAgreed,
        logout: Logout,
        switchAccounts: SwitchAccounts
    })
);
